import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
            position: 'relative',
            display: 'block',
        },
        customInputContainer: {
            display: 'flex',
            flexDirection: 'row',
            w: '100%',
            alignItems: 'center',
            gap: {
                base: 'xxsmall-1.base',
                md: 'xxsmall-1.md',
                lg: 'xxsmall-1.lg',
                xl: 'xxsmall-1.xl',
            },
        },
        customInput: {
            paddingX: {
                base: 'xxsmall-1.base',
                md: 'xxsmall-1.md',
                lg: 'xxsmall-1.lg',
                xl: 'xxsmall-1.xl',
            },
            paddingY: {
                base: 'xxsmall.base',
                md: 'xxsmall.md',
                lg: 'xxsmall.lg',
                xl: 'xxsmall.xl',
            },
            bg: 'background.neutral.default',
            width: '100%',
            cursor: 'pointer',
            height: remCalc(44),
            borderRadius: 'large-1',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
            border: '1px solid var(--chakra-colors-border-neutral-highlight)',

            _readOnly: {
                boxShadow:
                    '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
            },

            _hover: {
                bg: 'background.base.elevated',
            },

            _focus: {
                bg: 'background.base.elevated',
                border: '1px solid var(--chakra-colors-border-neutral-highlight) !important',
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-accent-md), 0 0 0 1px var(--chakra-shadows-accent-xl), 0 0 0 4px var(--chakra-shadows-accent-xs) !important',
            },

            _focusVisible: {
                bg: 'background.base.elevated',
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-accent-md), 0 0 0 1px var(--chakra-shadows-accent-xl), 0 0 0 4px var(--chakra-shadows-accent-xs)',
            },

            _focusWithin: {
                bg: 'background.base.elevated',
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-accent-md), 0 0 0 1px var(--chakra-shadows-accent-xl), 0 0 0 4px var(--chakra-shadows-accent-xs)',
            },

            _invalid: {
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-negative-md), 0 0 0 1px var(--chakra-shadows-negative-xl), 0 0 0 4px var(--chakra-shadows-negative-xs)',

                _focus: {
                    boxShadow:
                        '0 3px 6px 0 var(--chakra-shadows-accent-md), 0 0 0 1px var(--chakra-shadows-accent-xl), 0 0 0 4px var(--chakra-shadows-accent-xs) !important',
                },

                _focusVisible: {
                    outline: 'none',
                    boxShadow:
                        '0 3px 6px 0 var(--chakra-shadows-accent-md), 0 0 0 1px var(--chakra-shadows-accent-xl), 0 0 0 4px var(--chakra-shadows-accent-xs)',
                },

                _focusWithin: {
                    boxShadow:
                        '0 3px 6px 0 var(--chakra-shadows-accent-md), 0 0 0 1px var(--chakra-shadows-accent-xl), 0 0 0 4px var(--chakra-shadows-accent-xs)',
                },
            },

            _placeholder: {
                color: 'foreground.neutral.subtle !important',
            },
        },
        calendarIcon: {
            position: 'absolute',
            right: remCalc(12),
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            width: remCalc(16),
            height: remCalc(16),
            color: 'foreground.neutral.muted',
        },
        placeholderLabel: {
            textStyle: 'body-xxsmall',
            color: 'foreground.neutral.subtle',
            fontWeight: 'regular',
            lineHeight: remCalc(12),
        },
        inputText: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            color: 'foreground.neutral.default',
        },
        '.react-datepicker-wrapper': {
            width: '100%',
        },
        '.react-datepicker': {
            textStyle: 'body-small',
            borderColor: 'text.date-picker-grey',
        },
        '.react-datepicker__header': {
            backgroundColor: 'background.light-dark',
            borderColor: 'text.date-picker-grey',
        },
        '.react-datepicker__triangle': {
            borderColor: 'text.date-picker-grey',
        },
        '.react-datepicker-popper': {
            zIndex: 10,
            marginLeft: {
                base: remCalc(30),
                sm: remCalc(30),
                md: 0,
                lg: 0,
            },
        },

        '.react-datepicker__navigation-icon::before': {
            borderTop: 'small',
            borderRight: 'small',
            borderBottom: 0,
            borderLeft: 0,
            borderStyle: 'solid',
            borderColor: 'border.dark',
        },
        yearSelectContainer: {
            position: 'relative',
        },

        yearCombobox: {
            align: 'center',
            gap: remCalc(2),
            cursor: 'pointer',
            _focusVisible: {
                outline: `${remCalc(2)} solid`,
                outlineColor: 'black',
                outlineOffset: remCalc(2),
            },
        },

        yearText: {
            textStyle: 'body-small',
            fontWeight: 'normal',
        },

        yearChevronContainer: {
            transition: 'transform 0.2s',
        },

        yearChevronIcon: {
            width: remCalc(12),
            height: remCalc(12),
        },

        yearListbox: {
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            mt: 1,
            maxH: `${remCalc(200)}`,
            overflowY: 'auto',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.secondary',
            bg: 'background.default',
            zIndex: 20,
            minW: remCalc(80),
        },

        yearOption: {
            px: remCalc(3),
            py: remCalc(2),
            cursor: 'pointer',
            _hover: {
                background: 'background.light',
            },
        },

        yearOptionSelected: {
            background: 'background.light-dark',
            fontWeight: 'semibold',
        },

        headerContainer: {
            width: '100%',
        },

        monthControllsContainer: {
            alignItems: 'center',
            justifyContent: 'center',
        },

        monthSelectButton: {
            _focusVisible: {
                outline: `${remCalc(2)} solid`,
                outlineColor: 'black',
                outlineOffset: `${remCalc(2)}`,
            },
        },

        monthSelectIcon: {
            width: remCalc(17),
            height: remCalc(17),
        },

        monthContainer: {
            textStyle: 'body-medium',
            fontWeight: 'bold',
            textAlign: 'center',
        },

        yearsContainer: {
            justifyContent: 'center',
            py: 1,
        },
    },
    variants: {
        success: {
            customInput: {
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-positive-md), 0 0 0 1px var(--chakra-shadows-positive-xl), 0 0 0 4px var(--chakra-shadows-positive-xs)',
            },
        },
        disabled: {
            customInput: {
                bg: 'background.base.under !important',
                color: 'foreground.neutral.dim !important',
                border: '1px solid var(--chakra-colors-border-neutral-highlight) !important',
                cursor: 'not-allowed',
            },
            inputText: {
                cursor: 'not-allowed',
            },
        },
    },
}
